import React, { useState } from "react"
import dayjs from "dayjs"
import BottomCtaNavigation from "../../Common/BottomCtaNavigation"

const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/
const MIN_AGE = 18
const MAX_AGE = 120
const FORMAT_MESSAGE = "Please enter a valid date of birth in dd/mm/yyyy format."
const MIN_AGE_MESSAGE = `Please enter an age of ${MIN_AGE} or older.`

export function birthdayError(birthday) {
  if (!birthday) return FORMAT_MESSAGE
  if (!ISO_DATE_PATTERN.test(birthday)) return FORMAT_MESSAGE

  const parsed = dayjs(birthday)
  if (!parsed.isValid() || parsed.format("YYYY-MM-DD") !== birthday) return FORMAT_MESSAGE

  const age = dayjs().diff(parsed, "year")
  if (age > MAX_AGE) return FORMAT_MESSAGE
  if (age < MIN_AGE) return MIN_AGE_MESSAGE

  return null
}

function GeneralInfoSection({
  currentSection,
  form,
  groupName,
  onChangeHandler,
  questionSet,
  setCurrentSection,
  title,
  calculatorName
}) {
  const [warning, setWarning] = useState(null)
  const { questions } = questionSet
  const currentBirthday = _.get(form, `${questions[0].question_slug}.free_text_field`)
  const italicisedDescription = "Why do we ask for date of birth and sex?"
  const description = `The ${calculatorName || "MatchFit Calculator"} is based on the best available science-based research. Reporting your age and sex allows us to determine your biological age, as we compare your assessment responses to age and sex-matched population norms reported in epidemiological research. Your information remains confidential and no identifiable data linking you to your age or sex will be shared. Inclusivity and diversity are important to Performance Intelligence, in fact they form part of our company values. Our vision is to adapt techniques as science-based research evolves to support greater diversity.`
  const maxBirthday = dayjs().subtract(MIN_AGE, "year").format("YYYY-MM-DD")
  const minBirthday = dayjs().subtract(MAX_AGE, "year").format("YYYY-MM-DD")

  const onBirthdayChange = event => {
    setWarning(null)
    onChangeHandler(event)
  }

  const onNextStep = () => {
    const error = birthdayError(currentBirthday)
    if (error) {
      setWarning(error)
    } else {
      setWarning(null)
      setCurrentSection(currentSection + 1)
    }
  }

  if (currentSection !== questionSet.page_index) return null
  return (
    <>
      {groupName && <h5>{groupName}</h5>}
      <h1>{title}</h1>
      <hr />
      <div className="col-8 col-sm-5">
        <p>{questions[0].label}</p>
        <input
          className={`form-control ${warning ? "is-invalid" : ""}`}
          id={questions[0].answers[0].id}
          name={questions[0].question_slug}
          max={maxBirthday}
          min={minBirthday}
          onChange={onBirthdayChange}
          pattern="/d+"
          step="1"
          type="date"
          value={currentBirthday || ""} />
        {warning && (<p className="mt-3 text-danger">{warning}</p>)}
      </div>

      <div className="col-6 col-sm-5">
        <p className="mt-5">{questions[1].label}</p>
        <select
          className="form-control"
          id={questions[1].answers[0].id}
          name={questions[1].question_slug}
          onChange={onChangeHandler}
          value={_.get(form, `${questions[1].question_slug}.free_text_field`) || ""}>
          <option disabled value="">Select</option>
          <option value="female">Female</option>
          <option value="male">Male</option>
        </select>
      </div>
      {/* </div> */}
      <div className="q-group">
        <div className="col-12 mt-5">
          <i className="small">{italicisedDescription}</i>
          <p className="mt-2 small">{description}</p>
        </div>
      </div>
      <BottomCtaNavigation
        currentSection={0}
        lastPage={1}
        nextDisabled={_.difference(["birthday", "sex"], Object.keys(form)).length > 0}
        onNextStep={onNextStep}
        onPreviousStep={() => {}}
        onDone={() => {}} />
    </>
  )
}

export default GeneralInfoSection
